{
  "atlas": {
    "type": "msdf",
    "distanceRange": 2,
    "size": 59.65625,
    "width": 512,
    "height": 256,
    "yOrigin": "bottom"
  },
  "metrics": {
    "emSize": 1,
    "lineHeight": 1.171875,
    "ascender": 0.927734375,
    "descender": -0.244140625,
    "underlineY": -0.09765625,
    "underlineThickness": 0.048828125
  },
  "glyphs": [
    { "unicode": 32, "advance": 0.24755859375 },
    {
      "unicode": 33,
      "advance": 0.25732421875,
      "planeBounds": {
        "left": 0.056159633438645884,
        "bottom": -0.024377614056770559,
        "right": 0.20702396031135412,
        "top": 0.72994402030677052
      },
      "atlasBounds": {
        "left": 488.5,
        "bottom": 145.5,
        "right": 497.5,
        "top": 190.5
      }
    },
    {
      "unicode": 34,
      "advance": 0.31982421875,
      "planeBounds": {
        "left": 0.049409125974004715,
        "bottom": 0.48691155587022,
        "right": 0.28408696777599529,
        "top": 0.77187750662978005
      },
      "atlasBounds": {
        "left": 486.5,
        "bottom": 213.5,
        "right": 500.5,
        "top": 230.5
      }
    },
    {
      "unicode": 35,
      "advance": 0.61572265625,
      "planeBounds": {
        "left": 0.037219103997511785,
        "bottom": -0.021692067181770559,
        "right": 0.62391370850248817,
        "top": 0.73262956718177052
      },
      "atlasBounds": {
        "left": 66.5,
        "bottom": 51.5,
        "right": 101.5,
        "top": 96.5
      }
    },
    {
      "unicode": 36,
      "advance": 0.5615234375,
      "planeBounds": {
        "left": 0.02956531458715296,
        "bottom": -0.12381369908983761,
        "right": 0.53244640416284716,
        "top": 0.84842307408983775
      },
      "atlasBounds": {
        "left": 109.5,
        "bottom": 197.5,
        "right": 139.5,
        "top": 255.5
      }
    },
    {
      "unicode": 37,
      "advance": 0.732421875,
      "planeBounds": {
        "left": 0.026481776289942378,
        "bottom": -0.030073418674698794,
        "right": 0.71375259871005758,
        "top": 0.74101091867469893
      },
      "atlasBounds": {
        "left": 88.5,
        "bottom": 144.5,
        "right": 129.5,
        "top": 190.5
      }
    },
    {
      "unicode": 38,
      "advance": 0.62158203125,
      "planeBounds": {
        "left": 0.03225572125458355,
        "bottom": -0.030073418674698794,
        "right": 0.63571302874541658,
        "top": 0.74101091867469893
      },
      "atlasBounds": {
        "left": 130.5,
        "bottom": 144.5,
        "right": 166.5,
        "top": 190.5
      }
    },
    {
      "unicode": 39,
      "advance": 0.17431640625,
      "planeBounds": {
        "left": 0.028244602049502358,
        "bottom": 0.49895501673814824,
        "right": 0.14558352295049765,
        "top": 0.76715826451185176
      },
      "atlasBounds": {
        "left": 498.5,
        "bottom": 62.5,
        "right": 505.5,
        "top": 78.5
      }
    },
    {
      "unicode": 40,
      "advance": 0.341796875,
      "planeBounds": {
        "left": 0.042983329377291775,
        "bottom": -0.25002954242240699,
        "right": 0.34471198312270823,
        "top": 0.82278344867240716
      },
      "atlasBounds": {
        "left": 0.5,
        "bottom": 191.5,
        "right": 18.5,
        "top": 255.5
      }
    },
    {
      "unicode": 41,
      "advance": 0.34765625,
      "planeBounds": {
        "left": -0.0031592487477082251,
        "bottom": -0.25002954242240699,
        "right": 0.29856940499770823,
        "top": 0.82278344867240716
      },
      "atlasBounds": {
        "left": 19.5,
        "bottom": 191.5,
        "right": 37.5,
        "top": 255.5
      }
    },
    {
      "unicode": 42,
      "advance": 0.4306640625,
      "planeBounds": {
        "left": -0.011208599684062338,
        "bottom": 0.27785390031593765,
        "right": 0.44138438093406235,
        "top": 0.73044688093406229
      },
      "atlasBounds": {
        "left": 449.5,
        "bottom": 23.5,
        "right": 476.5,
        "top": 50.5
      }
    },
    {
      "unicode": 43,
      "advance": 0.56689453125,
      "planeBounds": {
        "left": 0.01353503347629649,
        "bottom": 0.053493525733368255,
        "right": 0.54994152902370363,
        "top": 0.6066627242666317
      },
      "atlasBounds": {
        "left": 361.5,
        "bottom": 17.5,
        "right": 393.5,
        "top": 50.5
      }
    },
    {
      "unicode": 44,
      "advance": 0.1962890625,
      "planeBounds": {
        "left": -0.0099194757972105828,
        "bottom": -0.15981695975478,
        "right": 0.17447025704721059,
        "top": 0.12514899100478
      },
      "atlasBounds": {
        "left": 498.5,
        "bottom": 79.5,
        "right": 509.5,
        "top": 96.5
      }
    },
    {
      "unicode": 45,
      "advance": 0.27587890625,
      "planeBounds": {
        "left": -0.00527594412977999,
        "bottom": 0.24333249267450235,
        "right": 0.27969000662978,
        "top": 0.36067141357549765
      },
      "atlasBounds": { "left": 52.5, "bottom": 7.5, "right": 69.5, "top": 14.5 }
    },
    {
      "unicode": 46,
      "advance": 0.26318359375,
      "planeBounds": {
        "left": 0.051032680313645884,
        "bottom": -0.027092319686354116,
        "right": 0.20189700718635412,
        "top": 0.12377200718635412
      },
      "atlasBounds": {
        "left": 501.5,
        "bottom": 221.5,
        "right": 510.5,
        "top": 230.5
      }
    },
    {
      "unicode": 47,
      "advance": 0.412109375,
      "planeBounds": {
        "left": -0.013733006073205867,
        "bottom": -0.085735051278483493,
        "right": 0.40533456857320588,
        "top": 0.73563739502848347
      },
      "atlasBounds": {
        "left": 252.5,
        "bottom": 206.5,
        "right": 277.5,
        "top": 255.5
      }
    },
    {
      "unicode": 48,
      "advance": 0.5615234375,
      "planeBounds": {
        "left": 0.037458384830081196,
        "bottom": -0.030073418674698794,
        "right": 0.52357677141991887,
        "top": 0.74101091867469893
      },
      "atlasBounds": {
        "left": 167.5,
        "bottom": 144.5,
        "right": 196.5,
        "top": 190.5
      }
    },
    {
      "unicode": 49,
      "advance": 0.5615234375,
      "planeBounds": {
        "left": 0.06023674350936354,
        "bottom": -0.019983082806770559,
        "right": 0.37872810024063647,
        "top": 0.73433855155677052
      },
      "atlasBounds": {
        "left": 488.5,
        "bottom": 97.5,
        "right": 507.5,
        "top": 142.5
      }
    },
    {
      "unicode": 50,
      "advance": 0.5615234375,
      "planeBounds": {
        "left": 0.025334353719224725,
        "bottom": -0.016809254681770559,
        "right": 0.54497814628077523,
        "top": 0.73751237968177052
      },
      "atlasBounds": {
        "left": 278.5,
        "bottom": 51.5,
        "right": 309.5,
        "top": 96.5
      }
    },
    {
      "unicode": 51,
      "advance": 0.5615234375,
      "planeBounds": {
        "left": 0.028181041080081196,
        "bottom": -0.030073418674698794,
        "right": 0.51429942766991887,
        "top": 0.74101091867469893
      },
      "atlasBounds": {
        "left": 197.5,
        "bottom": 144.5,
        "right": 226.5,
        "top": 190.5
      }
    },
    {
      "unicode": 52,
      "advance": 0.5615234375,
      "planeBounds": {
        "left": 0.0058861038583682551,
        "bottom": -0.021692067181770559,
        "right": 0.5590553023916317,
        "top": 0.73262956718177052
      },
      "atlasBounds": {
        "left": 310.5,
        "bottom": 51.5,
        "right": 343.5,
        "top": 96.5
      }
    },
    {
      "unicode": 53,
      "advance": 0.5615234375,
      "planeBounds": {
        "left": 0.055524791080081196,
        "bottom": -0.026574879681770559,
        "right": 0.54164317766991887,
        "top": 0.72774675468177052
      },
      "atlasBounds": {
        "left": 344.5,
        "bottom": 51.5,
        "right": 373.5,
        "top": 96.5
      }
    },
    {
      "unicode": 54,
      "advance": 0.5615234375,
      "planeBounds": {
        "left": 0.046003306705081196,
        "bottom": -0.034712090549698794,
        "right": 0.53212169329491887,
        "top": 0.73637224679969893
      },
      "atlasBounds": {
        "left": 227.5,
        "bottom": 144.5,
        "right": 256.5,
        "top": 190.5
      }
    },
    {
      "unicode": 55,
      "advance": 0.5615234375,
      "planeBounds": {
        "left": 0.018010134969224725,
        "bottom": -0.021692067181770559,
        "right": 0.53765392753077523,
        "top": 0.73262956718177052
      },
      "atlasBounds": {
        "left": 374.5,
        "bottom": 51.5,
        "right": 405.5,
        "top": 96.5
      }
    },
    {
      "unicode": 56,
      "advance": 0.5615234375,
      "planeBounds": {
        "left": 0.037702525455081196,
        "bottom": -0.030073418674698794,
        "right": 0.52382091204491887,
        "top": 0.74101091867469893
      },
      "atlasBounds": {
        "left": 257.5,
        "bottom": 144.5,
        "right": 286.5,
        "top": 190.5
      }
    },
    {
      "unicode": 57,
      "advance": 0.5615234375,
      "planeBounds": {
        "left": 0.029401744205081196,
        "bottom": -0.025434746799698794,
        "right": 0.51552013079491887,
        "top": 0.74564959054969893
      },
      "atlasBounds": {
        "left": 287.5,
        "bottom": 144.5,
        "right": 316.5,
        "top": 190.5
      }
    },
    {
      "unicode": 58,
      "advance": 0.2421875,
      "planeBounds": {
        "left": 0.046394008438645884,
        "bottom": -0.029431286627488215,
        "right": 0.19725833531135412,
        "top": 0.55726331787748817
      },
      "atlasBounds": {
        "left": 439.5,
        "bottom": 61.5,
        "right": 448.5,
        "top": 96.5
      }
    },
    {
      "unicode": 59,
      "advance": 0.21142578125,
      "planeBounds": {
        "left": 0.0010668523277894189,
        "bottom": -0.16459733294591408,
        "right": 0.18545658517221059,
        "top": 0.55619889544591405
      },
      "atlasBounds": {
        "left": 406.5,
        "bottom": 53.5,
        "right": 417.5,
        "top": 96.5
      }
    },
    {
      "unicode": 60,
      "advance": 0.50830078125,
      "planeBounds": {
        "left": 0.016948142433865897,
        "bottom": 0.072614634830081196,
        "right": 0.45277842006613411,
        "top": 0.55873302141991887
      },
      "atlasBounds": {
        "left": 394.5,
        "bottom": 21.5,
        "right": 420.5,
        "top": 50.5
      }
    },
    {
      "unicode": 61,
      "advance": 0.548828125,
      "planeBounds": {
        "left": 0.051535540940937666,
        "bottom": 0.17620354038436353,
        "right": 0.5041285215590624,
        "top": 0.49469489711563647
      },
      "atlasBounds": {
        "left": 477.5,
        "bottom": 31.5,
        "right": 504.5,
        "top": 50.5
      }
    },
    {
      "unicode": 62,
      "advance": 0.5224609375,
      "planeBounds": {
        "left": 0.047629290940937666,
        "bottom": 0.073102916080081196,
        "right": 0.5002222715590624,
        "top": 0.55922130266991887
      },
      "atlasBounds": {
        "left": 421.5,
        "bottom": 21.5,
        "right": 448.5,
        "top": 50.5
      }
    },
    {
      "unicode": 63,
      "advance": 0.47216796875,
      "planeBounds": {
        "left": 0.016704001808865897,
        "bottom": -0.027876153049698794,
        "right": 0.45253427944113411,
        "top": 0.74320818429969893
      },
      "atlasBounds": {
        "left": 317.5,
        "bottom": 144.5,
        "right": 343.5,
        "top": 190.5
      }
    },
    {
      "unicode": 64,
      "advance": 0.89794921875,
      "planeBounds": {
        "left": 0.034064457306783605,
        "bottom": -0.23896750384690937,
        "right": 0.87219960659960716,
        "top": 0.71650656634690935
      },
      "atlasBounds": {
        "left": 155.5,
        "bottom": 198.5,
        "right": 205.5,
        "top": 255.5
      }
    },
    {
      "unicode": 65,
      "advance": 0.65234375,
      "planeBounds": {
        "left": -0.0088380440921293872,
        "bottom": -0.021692067181770559,
        "right": 0.66167007534212952,
        "top": 0.73262956718177052
      },
      "atlasBounds": {
        "left": 237.5,
        "bottom": 51.5,
        "right": 277.5,
        "top": 96.5
      }
    },
    {
      "unicode": 66,
      "advance": 0.62255859375,
      "planeBounds": {
        "left": 0.064640994344224725,
        "bottom": -0.021692067181770559,
        "right": 0.58428478690577523,
        "top": 0.73262956718177052
      },
      "atlasBounds": {
        "left": 205.5,
        "bottom": 51.5,
        "right": 236.5,
        "top": 96.5
      }
    },
    {
      "unicode": 67,
      "advance": 0.65087890625,
      "planeBounds": {
        "left": 0.038439807122511785,
        "bottom": -0.030073418674698794,
        "right": 0.62513441162748817,
        "top": 0.74101091867469893
      },
      "atlasBounds": {
        "left": 344.5,
        "bottom": 144.5,
        "right": 379.5,
        "top": 190.5
      }
    },
    {
      "unicode": 68,
      "advance": 0.65576171875,
      "planeBounds": {
        "left": 0.063015010108368255,
        "bottom": -0.021692067181770559,
        "right": 0.6161842086416317,
        "top": 0.73262956718177052
      },
      "atlasBounds": {
        "left": 162.5,
        "bottom": 51.5,
        "right": 195.5,
        "top": 96.5
      }
    },
    {
      "unicode": 69,
      "advance": 0.568359375,
      "planeBounds": {
        "left": 0.065290416080081196,
        "bottom": -0.021692067181770559,
        "right": 0.55140880266991887,
        "top": 0.73262956718177052
      },
      "atlasBounds": {
        "left": 132.5,
        "bottom": 51.5,
        "right": 161.5,
        "top": 96.5
      }
    },
    {
      "unicode": 70,
      "advance": 0.552734375,
      "planeBounds": {
        "left": 0.059675181705081196,
        "bottom": -0.021692067181770559,
        "right": 0.54579356829491887,
        "top": 0.73262956718177052
      },
      "atlasBounds": {
        "left": 102.5,
        "bottom": 51.5,
        "right": 131.5,
        "top": 96.5
      }
    },
    {
      "unicode": 71,
      "advance": 0.68115234375,
      "planeBounds": {
        "left": 0.040148791497511785,
        "bottom": -0.030073418674698794,
        "right": 0.62684339600248817,
        "top": 0.74101091867469893
      },
      "atlasBounds": {
        "left": 380.5,
        "bottom": 144.5,
        "right": 415.5,
        "top": 190.5
      }
    },
    {
      "unicode": 72,
      "advance": 0.712890625,
      "planeBounds": {
        "left": 0.062365588372511785,
        "bottom": -0.021692067181770559,
        "right": 0.64906019287748817,
        "top": 0.73262956718177052
      },
      "atlasBounds": {
        "left": 30.5,
        "bottom": 51.5,
        "right": 65.5,
        "top": 96.5
      }
    },
    {
      "unicode": 73,
      "advance": 0.27197265625,
      "planeBounds": {
        "left": 0.069179656806574119,
        "bottom": -0.021692067181770559,
        "right": 0.20328128069342588,
        "top": 0.73262956718177052
      },
      "atlasBounds": {
        "left": 196.5,
        "bottom": 51.5,
        "right": 204.5,
        "top": 96.5
      }
    },
    {
      "unicode": 74,
      "advance": 0.5517578125,
      "planeBounds": {
        "left": 0.0071849473300811938,
        "bottom": -0.026574879681770559,
        "right": 0.49330333391991882,
        "top": 0.72774675468177052
      },
      "atlasBounds": { "left": 0.5, "bottom": 51.5, "right": 29.5, "top": 96.5 }
    },
    {
      "unicode": 75,
      "advance": 0.626953125,
      "planeBounds": {
        "left": 0.061633166497511785,
        "bottom": -0.021692067181770559,
        "right": 0.64832777100248817,
        "top": 0.73262956718177052
      },
      "atlasBounds": {
        "left": 452.5,
        "bottom": 97.5,
        "right": 487.5,
        "top": 142.5
      }
    },
    {
      "unicode": 76,
      "advance": 0.5380859375,
      "planeBounds": {
        "left": 0.063417861323009431,
        "bottom": -0.021692067181770559,
        "right": 0.53277354492699058,
        "top": 0.73262956718177052
      },
      "atlasBounds": {
        "left": 423.5,
        "bottom": 97.5,
        "right": 451.5,
        "top": 142.5
      }
    },
    {
      "unicode": 77,
      "advance": 0.873046875,
      "planeBounds": {
        "left": 0.059118479693229441,
        "bottom": -0.021692067181770559,
        "right": 0.81344011405677052,
        "top": 0.73262956718177052
      },
      "atlasBounds": {
        "left": 377.5,
        "bottom": 97.5,
        "right": 422.5,
        "top": 142.5
      }
    },
    {
      "unicode": 78,
      "advance": 0.712890625,
      "planeBounds": {
        "left": 0.062365588372511785,
        "bottom": -0.021692067181770559,
        "right": 0.64906019287748817,
        "top": 0.73262956718177052
      },
      "atlasBounds": {
        "left": 341.5,
        "bottom": 97.5,
        "right": 376.5,
        "top": 142.5
      }
    },
    {
      "unicode": 79,
      "advance": 0.6875,
      "planeBounds": {
        "left": 0.033395854136655315,
        "bottom": -0.030073418674698794,
        "right": 0.65361586461334464,
        "top": 0.74101091867469893
      },
      "atlasBounds": {
        "left": 416.5,
        "bottom": 144.5,
        "right": 453.5,
        "top": 190.5
      }
    },
    {
      "unicode": 80,
      "advance": 0.630859375,
      "planeBounds": {
        "left": 0.061550166358368255,
        "bottom": -0.021692067181770559,
        "right": 0.6147193648916317,
        "top": 0.73262956718177052
      },
      "atlasBounds": {
        "left": 273.5,
        "bottom": 97.5,
        "right": 306.5,
        "top": 142.5
      }
    },
    {
      "unicode": 81,
      "advance": 0.6875,
      "planeBounds": {
        "left": 0.030466166636655315,
        "bottom": -0.14391866037519643,
        "right": 0.65068617711334464,
        "top": 0.74450459787519641
      },
      "atlasBounds": {
        "left": 214.5,
        "bottom": 202.5,
        "right": 251.5,
        "top": 255.5
      }
    },
    {
      "unicode": 82,
      "advance": 0.61572265625,
      "planeBounds": {
        "left": 0.063503291358368255,
        "bottom": -0.021692067181770559,
        "right": 0.6166724898916317,
        "top": 0.73262956718177052
      },
      "atlasBounds": {
        "left": 186.5,
        "bottom": 97.5,
        "right": 219.5,
        "top": 142.5
      }
    },
    {
      "unicode": 83,
      "advance": 0.59326171875,
      "planeBounds": {
        "left": 0.020778681983368255,
        "bottom": -0.030073418674698794,
        "right": 0.5739478805166317,
        "top": 0.74101091867469893
      },
      "atlasBounds": {
        "left": 454.5,
        "bottom": 144.5,
        "right": 487.5,
        "top": 190.5
      }
    },
    {
      "unicode": 84,
      "advance": 0.5966796875,
      "planeBounds": {
        "left": 0.0054808227475117866,
        "bottom": -0.021692067181770559,
        "right": 0.59217542725248817,
        "top": 0.73262956718177052
      },
      "atlasBounds": {
        "left": 112.5,
        "bottom": 97.5,
        "right": 147.5,
        "top": 142.5
      }
    },
    {
      "unicode": 85,
      "advance": 0.6484375,
      "planeBounds": {
        "left": 0.049098994483368255,
        "bottom": -0.026574879681770559,
        "right": 0.6022681930166317,
        "top": 0.72774675468177052
      },
      "atlasBounds": {
        "left": 78.5,
        "bottom": 97.5,
        "right": 111.5,
        "top": 142.5
      }
    },
    {
      "unicode": 86,
      "advance": 0.63623046875,
      "planeBounds": {
        "left": -0.0082691925992011521,
        "bottom": -0.021692067181770559,
        "right": 0.64547622384920111,
        "top": 0.73262956718177052
      },
      "atlasBounds": {
        "left": 38.5,
        "bottom": 97.5,
        "right": 77.5,
        "top": 142.5
      }
    },
    {
      "unicode": 87,
      "advance": 0.88720703125,
      "planeBounds": {
        "left": 0.011923628617731797,
        "bottom": -0.021692067181770559,
        "right": 0.88358418388226834,
        "top": 0.73262956718177052
      },
      "atlasBounds": {
        "left": 220.5,
        "bottom": 97.5,
        "right": 272.5,
        "top": 142.5
      }
    },
    {
      "unicode": 88,
      "advance": 0.626953125,
      "planeBounds": {
        "left": 0.0040989791366553164,
        "bottom": -0.021692067181770559,
        "right": 0.62431898961334464,
        "top": 0.73262956718177052
      },
      "atlasBounds": {
        "left": 0.5,
        "bottom": 97.5,
        "right": 37.5,
        "top": 142.5
      }
    },
    {
      "unicode": 89,
      "advance": 0.6005859375,
      "planeBounds": {
        "left": -0.010793598988344685,
        "bottom": -0.021692067181770559,
        "right": 0.60942641148834464,
        "top": 0.73262956718177052
      },
      "atlasBounds": {
        "left": 148.5,
        "bottom": 97.5,
        "right": 185.5,
        "top": 142.5
      }
    },
    {
      "unicode": 90,
      "advance": 0.5986328125,
      "planeBounds": {
        "left": 0.024196650733368255,
        "bottom": -0.021692067181770559,
        "right": 0.5773658492666317,
        "top": 0.73262956718177052
      },
      "atlasBounds": {
        "left": 307.5,
        "bottom": 97.5,
        "right": 340.5,
        "top": 142.5
      }
    },
    {
      "unicode": 91,
      "advance": 0.26513671875,
      "planeBounds": {
        "left": 0.05437250871693295,
        "bottom": -0.17280296457569408,
        "right": 0.27228764753306706,
        "top": 0.83295921457569422
      },
      "atlasBounds": {
        "left": 59.5,
        "bottom": 195.5,
        "right": 72.5,
        "top": 255.5
      }
    },
    {
      "unicode": 92,
      "advance": 0.41015625,
      "planeBounds": {
        "left": 0.0014037126767941326,
        "bottom": -0.085735051278483493,
        "right": 0.42047128732320588,
        "top": 0.73563739502848347
      },
      "atlasBounds": {
        "left": 278.5,
        "bottom": 206.5,
        "right": 303.5,
        "top": 255.5
      }
    },
    {
      "unicode": 93,
      "advance": 0.26513671875,
      "planeBounds": {
        "left": -0.020659233400995285,
        "bottom": -0.17280296457569408,
        "right": 0.21401860840099529,
        "top": 0.83295921457569422
      },
      "atlasBounds": {
        "left": 94.5,
        "bottom": 195.5,
        "right": 108.5,
        "top": 255.5
      }
    },
    {
      "unicode": 94,
      "advance": 0.41796875,
      "planeBounds": {
        "left": 0.0068553766697223677,
        "bottom": 0.33229482979472236,
        "right": 0.40916024833027764,
        "top": 0.73459970145527764
      },
      "atlasBounds": {
        "left": 486.5,
        "bottom": 231.5,
        "right": 510.5,
        "top": 255.5
      }
    },
    {
      "unicode": 95,
      "advance": 0.451171875,
      "planeBounds": {
        "left": -0.017473255794918804,
        "bottom": -0.095534694825497646,
        "right": 0.46864513079491882,
        "top": 0.021804226075497646
      },
      "atlasBounds": { "left": 70.5, "bottom": 7.5, "right": 99.5, "top": 14.5 }
    },
    {
      "unicode": 96,
      "advance": 0.30908203125,
      "planeBounds": {
        "left": 0.0039183994810764802,
        "bottom": 0.58602778982778947,
        "right": 0.25535894426892353,
        "top": 0.77041752267221053
      },
      "atlasBounds": { "left": 36.5, "bottom": 3.5, "right": 51.5, "top": 14.5 }
    },
    {
      "unicode": 97,
      "advance": 0.5439453125,
      "planeBounds": {
        "left": 0.028181041080081196,
        "bottom": -0.029187146002488215,
        "right": 0.51429942766991887,
        "top": 0.55750745850248817
      },
      "atlasBounds": {
        "left": 30.5,
        "bottom": 15.5,
        "right": 59.5,
        "top": 50.5
      }
    },
    {
      "unicode": 98,
      "advance": 0.56103515625,
      "planeBounds": {
        "left": 0.048932994205081196,
        "bottom": -0.032187684160555265,
        "right": 0.53505138079491887,
        "top": 0.7724220591605554
      },
      "atlasBounds": {
        "left": 304.5,
        "bottom": 207.5,
        "right": 333.5,
        "top": 255.5
      }
    },
    {
      "unicode": 99,
      "advance": 0.5234375,
      "planeBounds": {
        "left": 0.024518931705081196,
        "bottom": -0.029187146002488215,
        "right": 0.51063731829491887,
        "top": 0.55750745850248817
      },
      "atlasBounds": { "left": 0.5, "bottom": 15.5, "right": 29.5, "top": 50.5 }
    },
    {
      "unicode": 100,
      "advance": 0.56396484375,
      "planeBounds": {
        "left": 0.026227916080081196,
        "bottom": -0.032187684160555265,
        "right": 0.51234630266991887,
        "top": 0.7724220591605554
      },
      "atlasBounds": {
        "left": 334.5,
        "bottom": 207.5,
        "right": 363.5,
        "top": 255.5
      }
    },
    {
      "unicode": 101,
      "advance": 0.52978515625,
      "planeBounds": {
        "left": 0.026472056705081196,
        "bottom": -0.029187146002488215,
        "right": 0.51259044329491887,
        "top": 0.55750745850248817
      },
      "atlasBounds": {
        "left": 468.5,
        "bottom": 61.5,
        "right": 497.5,
        "top": 96.5
      }
    },
    {
      "unicode": 102,
      "advance": 0.34716796875,
      "planeBounds": {
        "left": 0.0045751109055788379,
        "bottom": -0.022177918535555265,
        "right": 0.37335457659442117,
        "top": 0.7824318247855554
      },
      "atlasBounds": {
        "left": 364.5,
        "bottom": 207.5,
        "right": 386.5,
        "top": 255.5
      }
    },
    {
      "unicode": 103,
      "advance": 0.56103515625,
      "planeBounds": {
        "left": 0.026960337955081196,
        "bottom": -0.22888445766762702,
        "right": 0.51307872454491887,
        "top": 0.55896258266762699
      },
      "atlasBounds": {
        "left": 28.5,
        "bottom": 143.5,
        "right": 57.5,
        "top": 190.5
      }
    },
    {
      "unicode": 104,
      "advance": 0.55078125,
      "planeBounds": {
        "left": 0.049826556565937666,
        "bottom": -0.01892352016762703,
        "right": 0.5024195371840624,
        "top": 0.76892352016762699
      },
      "atlasBounds": {
        "left": 0.5,
        "bottom": 143.5,
        "right": 27.5,
        "top": 190.5
      }
    },
    {
      "unicode": 105,
      "advance": 0.24267578125,
      "planeBounds": {
        "left": 0.046882289688645884,
        "bottom": -0.016809254681770559,
        "right": 0.19774661656135412,
        "top": 0.73751237968177052
      },
      "atlasBounds": {
        "left": 498.5,
        "bottom": 145.5,
        "right": 507.5,
        "top": 190.5
      }
    },
    {
      "unicode": 106,
      "advance": 0.23876953125,
      "planeBounds": {
        "left": -0.048979545900995285,
        "bottom": -0.23245627721483761,
        "right": 0.18569829590099529,
        "top": 0.73978049596483775
      },
      "atlasBounds": {
        "left": 140.5,
        "bottom": 197.5,
        "right": 154.5,
        "top": 255.5
      }
    },
    {
      "unicode": 107,
      "advance": 0.5068359375,
      "planeBounds": {
        "left": 0.044294322330081196,
        "bottom": -0.01892352016762703,
        "right": 0.53041270891991887,
        "top": 0.76892352016762699
      },
      "atlasBounds": {
        "left": 58.5,
        "bottom": 143.5,
        "right": 87.5,
        "top": 190.5
      }
    },
    {
      "unicode": 108,
      "advance": 0.24267578125,
      "planeBounds": {
        "left": 0.054287078681574119,
        "bottom": -0.01892352016762703,
        "right": 0.18838870256842588,
        "top": 0.76892352016762699
      },
      "atlasBounds": {
        "left": 477.5,
        "bottom": 208.5,
        "right": 485.5,
        "top": 255.5
      }
    },
    {
      "unicode": 109,
      "advance": 0.87646484375,
      "planeBounds": {
        "left": 0.04430890170737297,
        "bottom": -0.024304333502488215,
        "right": 0.83215594204262699,
        "top": 0.56239027100248817
      },
      "atlasBounds": {
        "left": 116.5,
        "bottom": 15.5,
        "right": 163.5,
        "top": 50.5
      }
    },
    {
      "unicode": 110,
      "advance": 0.5517578125,
      "planeBounds": {
        "left": 0.049826556565937666,
        "bottom": -0.024304333502488215,
        "right": 0.5024195371840624,
        "top": 0.56239027100248817
      },
      "atlasBounds": {
        "left": 60.5,
        "bottom": 15.5,
        "right": 87.5,
        "top": 50.5
      }
    },
    {
      "unicode": 111,
      "advance": 0.5703125,
      "planeBounds": {
        "left": 0.025090213094224725,
        "bottom": -0.029187146002488215,
        "right": 0.54473400565577523,
        "top": 0.55750745850248817
      },
      "atlasBounds": {
        "left": 193.5,
        "bottom": 15.5,
        "right": 224.5,
        "top": 50.5
      }
    },
    {
      "unicode": 112,
      "advance": 0.56103515625,
      "planeBounds": {
        "left": 0.048444712955081196,
        "bottom": -0.22644305141762702,
        "right": 0.53456309954491887,
        "top": 0.56140398891762699
      },
      "atlasBounds": {
        "left": 447.5,
        "bottom": 208.5,
        "right": 476.5,
        "top": 255.5
      }
    },
    {
      "unicode": 113,
      "advance": 0.568359375,
      "planeBounds": {
        "left": 0.025983775455081196,
        "bottom": -0.22644305141762702,
        "right": 0.51210216204491887,
        "top": 0.56140398891762699
      },
      "atlasBounds": {
        "left": 417.5,
        "bottom": 208.5,
        "right": 446.5,
        "top": 255.5
      }
    },
    {
      "unicode": 114,
      "advance": 0.33837890625,
      "planeBounds": {
        "left": 0.045180595002291775,
        "bottom": -0.024304333502488215,
        "right": 0.34690924874770823,
        "top": 0.56239027100248817
      },
      "atlasBounds": {
        "left": 449.5,
        "bottom": 61.5,
        "right": 467.5,
        "top": 96.5
      }
    },
    {
      "unicode": 115,
      "advance": 0.515625,
      "planeBounds": {
        "left": 0.021669814448009427,
        "bottom": -0.029187146002488215,
        "right": 0.49102549805199058,
        "top": 0.55750745850248817
      },
      "atlasBounds": {
        "left": 164.5,
        "bottom": 15.5,
        "right": 192.5,
        "top": 50.5
      }
    },
    {
      "unicode": 116,
      "advance": 0.32666015625,
      "planeBounds": {
        "left": -0.019433670483564695,
        "bottom": -0.028774575202985861,
        "right": 0.3158203892335647,
        "top": 0.67525895020298599
      },
      "atlasBounds": {
        "left": 418.5,
        "bottom": 54.5,
        "right": 438.5,
        "top": 96.5
      }
    },
    {
      "unicode": 117,
      "advance": 0.55126953125,
      "planeBounds": {
        "left": 0.048117572190937666,
        "bottom": -0.034069958502488215,
        "right": 0.5007105528090624,
        "top": 0.55262464600248817
      },
      "atlasBounds": {
        "left": 88.5,
        "bottom": 15.5,
        "right": 115.5,
        "top": 50.5
      }
    },
    {
      "unicode": 118,
      "advance": 0.484375,
      "planeBounds": {
        "left": -0.0020923964199188062,
        "bottom": -0.02080579450955998,
        "right": 0.48402599016991882,
        "top": 0.5491261070095601
      },
      "atlasBounds": {
        "left": 331.5,
        "bottom": 16.5,
        "right": 360.5,
        "top": 50.5
      }
    },
    {
      "unicode": 119,
      "advance": 0.75146484375,
      "planeBounds": {
        "left": -0.002649098431770561,
        "bottom": -0.02080579450955998,
        "right": 0.75167253593177052,
        "top": 0.5491261070095601
      },
      "atlasBounds": {
        "left": 225.5,
        "bottom": 16.5,
        "right": 270.5,
        "top": 50.5
      }
    },
    {
      "unicode": 120,
      "advance": 0.49560546875,
      "planeBounds": {
        "left": -0.0046143729128470395,
        "bottom": -0.02080579450955998,
        "right": 0.49826671666284711,
        "top": 0.5491261070095601
      },
      "atlasBounds": {
        "left": 300.5,
        "bottom": 16.5,
        "right": 330.5,
        "top": 50.5
      }
    },
    {
      "unicode": 121,
      "advance": 0.47314453125,
      "planeBounds": {
        "left": -0.0072193495449188062,
        "bottom": -0.23645281704262702,
        "right": 0.47889903704491882,
        "top": 0.55139422329262699
      },
      "atlasBounds": {
        "left": 387.5,
        "bottom": 208.5,
        "right": 416.5,
        "top": 255.5
      }
    },
    {
      "unicode": 122,
      "advance": 0.49560546875,
      "planeBounds": {
        "left": 0.018007705073009427,
        "bottom": -0.02080579450955998,
        "right": 0.48736338867699058,
        "top": 0.5491261070095601
      },
      "atlasBounds": {
        "left": 271.5,
        "bottom": 16.5,
        "right": 299.5,
        "top": 50.5
      }
    },
    {
      "unicode": 123,
      "advance": 0.33837890625,
      "planeBounds": {
        "left": 0.011572188891435306,
        "bottom": -0.20234398020069408,
        "right": 0.3468262486085647,
        "top": 0.80341819895069422
      },
      "atlasBounds": {
        "left": 73.5,
        "bottom": 195.5,
        "right": 93.5,
        "top": 255.5
      }
    },
    {
      "unicode": 124,
      "advance": 0.24365234375,
      "planeBounds": {
        "left": 0.063156711424502354,
        "bottom": -0.15466084787519643,
        "right": 0.18049563232549765,
        "top": 0.73376241037519641
      },
      "atlasBounds": {
        "left": 206.5,
        "bottom": 202.5,
        "right": 213.5,
        "top": 255.5
      }
    },
    {
      "unicode": 125,
      "advance": 0.33837890625,
      "planeBounds": {
        "left": -0.010156326733564695,
        "bottom": -0.20234398020069408,
        "right": 0.3250977329835647,
        "top": 0.80341819895069422
      },
      "atlasBounds": {
        "left": 38.5,
        "bottom": 195.5,
        "right": 58.5,
        "top": 255.5
      }
    },
    {
      "unicode": 126,
      "advance": 0.68017578125,
      "planeBounds": {
        "left": 0.046984728997511785,
        "bottom": 0.17660639159900471,
        "right": 0.63367933350248817,
        "top": 0.41128423340099529
      },
      "atlasBounds": { "left": 0.5, "bottom": 0.5, "right": 35.5, "top": 14.5 }
    }
  ],
  "kerning": []
}
